import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Component } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N300 } from '@atlaskit/theme/colors';
import ColumnCell from './internal/common-cell';
import withColumnWidth from './internal/with-column-width';
var headerStyles = css({
  color: "var(--ds-text-subtle, ".concat(N300, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-bold, 700)"
});

/**
 * This is hard-coded here because our actual <Header /> has no typings
 * for its props.
 *
 * Adding types for real *might* break things so will need a little care.
 *
 * Defining it here for now lets us provide *something* without much headache.
 */
var HeaderComponent = /*#__PURE__*/function (_Component) {
  _inherits(HeaderComponent, _Component);
  var _super = _createSuper(HeaderComponent);
  function HeaderComponent() {
    _classCallCheck(this, HeaderComponent);
    return _super.apply(this, arguments);
  }
  _createClass(HeaderComponent, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return (
        // TODO: Determine whether proper `th` elements can be used instead of
        // roles (DSP-11588)
        jsx(ColumnCell, _extends({
          css: headerStyles,
          role: "columnheader",
          style: {
            width: props.width
          }
        }, props), props.children)
      );
    }
  }]);
  return HeaderComponent;
}(Component);
var Header = withColumnWidth(HeaderComponent);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Header;